import { oc } from '@orpc/contract';
import { depreciationPresetsOutputSchema } from '../schemas/templates.schemas.js';
/** Starter presets only pre-fill rates; the template version then owns them (plan §3.2). */
export const listDepreciationPresetsContract = oc
    .route({
    method: 'GET',
    path: '/templates/presets',
    tags: ['Templates'],
    summary: 'The starter depreciation presets',
})
    .output(depreciationPresetsOutputSchema);
//# sourceMappingURL=list-depreciation-presets.contract.js.map